import React, { useEffect, useState } from 'react'
import { Grid, Box, Typography, Paper } from '@mui/material'
import { Link } from 'react-router-dom'
import CommentIcon from '@mui/icons-material/Comment'
import { fetchUniversityDashboardStats } from '../api/universityApi'

const TotalUniversitiesSummaryCards = () => {

  const [cards, setStatusList] = useState([
    { label: 'All University', count: 0 },
    { label: 'Live University', count: 0 },
    { label: 'Pending Approval', count: 0 },
    { label: 'Archive University', count: 0 },
    { label: 'Deactivated University', count: 0 },
    { label: 'Draft', count: 0 }
  ])

  useEffect(() => {
    fetchUniversityDashboardStats(setStatusList)
  }, [])


  return (
    <Grid container spacing={0} sx={{ p: 2, }}>
      {/* {cards.map((card, index) => (
        <Grid size={{ xs: 12, sm: 6, md: 2, xl: 2, }} key={index}>
          <Paper
            elevation={1}
            sx={{
              p: 1.5,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              border: '1px solid #e0e0e0',
              boxShadow: 'none',
              borderRight: index !== cards.length - 1 ? 'none' : undefined,
              borderRadius: 0,
              borderTopLeftRadius: index === 0 ? 8 : 0,
              borderTopRightRadius: index === cards.length - 1 ? 8 : 0,
              borderBottomLeftRadius: index === 0 ? 8 : 0,
              borderBottomRightRadius: index === cards.length - 1 ? 8 : 0,
            }}
          >
            <Box mb={2}>
              <Typography variant="h6" fontWeight={500} sx={{ fontSize: '18px', color: '#1075FF' }}>
                {card.value}
              </Typography>
              <Typography sx={{ fontSize: '14px', color: '#6E7485' }}>
                {card.title}
              </Typography>
            </Box>

            <Link
              to={card.link}
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                fontSize: '12px',
                fontWeight: 500,
                color: '#5D5DFF',
              }}
            >
              <CommentIcon sx={{ fontSize: 16, mr: 0.5 }} />
              Go To Comment
            </Link>
          </Paper>
        </Grid>
      ))} */}
    </Grid>
  )
}

export default TotalUniversitiesSummaryCards
